import React from 'react';
import { lensPath, view, set, Lens } from 'ramda';
import { useEditContext } from '../../crud-graphql-containers/ResourceEditContainer/EditContext';

export function useEditContextForInput<T>(field: string) {
  const defaultValue = (val: object | undefined | string) => {
    if (typeof val === 'string') {
      return '';
    }
    if (Array.isArray(val)) {
      return [];
    }
    return '';
  };

  const context = useEditContext();

  let lensToItem: Lens = lensPath(field.split('.'));
  const initialValue: Object = view(lensToItem, context.item);
  const value = (initialValue || defaultValue(initialValue)) as T;
  const [fieldValue, setFieldValue] = React.useState<T | null>(value);

  React.useEffect(() => {
    setFieldValue(value);
    // tslint:disable-next-line
  }, [field]);

  const onChange = (val: T | null) => {
    setFieldValue(val);
    context.item = set(lensToItem, val, context.item);
  };

  return {
    fieldValue,
    setFieldValue,
    onChange,
  };
}
